module.exports = __webpack_public_path__ + "static/img/preview.8548e8a0.png";